import * as React from 'react';
import GlobalStyles from '@mui/joy/GlobalStyles';
import Sheet from '@mui/joy/Sheet';
import IconButton from '@mui/joy/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import { toggleSidebar } from '../drawer/utils';
import { DynamicLogo } from '../layout/navbar/dynamicLogo';
import { Box } from '@mui/joy';
import { NotificationDropdown } from '../layout/navbar/notificationDropdown';

export function Header() {
  return (
    <Sheet
      sx={{
        display: { xs: 'flex' },
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        top: 0,
        width: '100vw',
        height: 'var(--Header-height)',
        zIndex: 100,
        p: 2,
        gap: 1,
        borderBottom: '1px solid',
        borderColor: 'background.level1',
        boxShadow: 'sm',
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ':root': {
            '--Header-height': '76px',
          },
        })}
      />
      <IconButton
        onClick={() => toggleSidebar()}
        variant="outlined"
        color="neutral"
        size="sm"
      >
        <MenuIcon />
      </IconButton>

      <Box
        sx={{
          display: { xs: 'block', lg: 'none' },
        }}
      >
        <DynamicLogo />
      </Box>

      <Box sx={{ paddingRight: '1.5rem' }}>
        <NotificationDropdown />
      </Box>
    </Sheet>
  );
}
